import type { FetchSuggestedTopicsResponse } from '@atlassian/jira-servicedesk-knowledge-common/src/services/fetch-suggested-topics/types.tsx';

export const FETCH_SUGGESTED_TOPICS_SUCCESS =
	'state.actions.fetch-suggested-topics-success.FETCH_SUGGESTED_TOPICS_SUCCESS' as const;

export type FetchSuggestedTopicsSuccessAction = {
	type: typeof FETCH_SUGGESTED_TOPICS_SUCCESS;
	payload: FetchSuggestedTopicsResponse;
};

export const fetchSuggestedTopicsSuccess = (
	payload: FetchSuggestedTopicsResponse,
): FetchSuggestedTopicsSuccessAction => ({
	type: FETCH_SUGGESTED_TOPICS_SUCCESS,
	payload,
});
